import $ from 'jquery';

;(function( $, window, document, undefined ) {
  $.fn.clickTwiceToGo = function( params ) {

    this.each( function() {
      var curItem = false;

      $( this ).on( 'click', function( e ) {
        var item = $( this );

        if( item[ 0 ] != curItem[ 0 ] ) {
          e.preventDefault();
          curItem = item;
        }
      });

      $( document ).keydown( function( e ) {
        if ( e.keyCode === 27 ) {
          curItem = false;
        }
      });

      $( document ).on( 'click touchstart MSPointerDown', function( e ) {
        let resetItem = true;

        if( $( e.target )[ 0 ] == curItem[ 0 ] ) {
          resetItem = false;
        }

        if( resetItem ) {
          curItem = false;
        }

      });
    });

    return this;
  };
})( $, window, document );

